var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.question ? _c('div', [_c('v-simple-table', {
    staticClass: "v-data-table--line table-fixed"
  }, [_c('tbody', [_c('tr', [_c('th', [_c('span', {
    staticClass: "break-words"
  }, [_vm._v(_vm._s(_vm.question.subject))])])]), _c('tr', [_c('td', [_c('u-divider-group', [_c('li', [_vm._v("작성일 : " + _vm._s(_vm.question.createdAt.toDate()))])])], 1)]), _vm.question.content ? _c('tr', [_c('td', [_c('div', {
    staticClass: "min-h-100px min-h-md-150px break-words",
    domProps: {
      "innerHTML": _vm._s(_vm.question.content.replace(/\n/g, '<br>'))
    }
  })])]) : _vm._e(), _vm.question.reply ? _c('tr', [_c('td', [_c('div', {
    staticClass: "min-h-100px min-h-md-150px break-words",
    domProps: {
      "innerHTML": _vm._s(_vm.question.reply.replace(/\n/g, '<br>'))
    }
  })])]) : _vm._e()])]), _c('div', {
    staticClass: "btn-wrap btn-wrap--sm"
  }, [_c('v-row', {
    staticClass: "row--xs"
  }, [_c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', _vm._b({
    on: {
      "click": _vm.list
    }
  }, 'v-btn', Object.assign({}, _vm.btn_secondary), false), [_vm._v("리스트")])], 1)], 1)], 1)], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }